import React from 'react';
import BandwidthBreakdown from './BandwidthBreakdown';

const BandwidthDashboard = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-cf-gray-900 mb-2">Bandwidth Breakdown</h1>
        <p className="text-sm text-cf-gray-600">Upload and analyze bandwidth usage from your DigitalOcean bandwidth CSV reports.</p>
      </div>

      <BandwidthBreakdown />
    </div>
  );
};

export default BandwidthDashboard;
